export default [
  {
    id: 1,
    first_name: 'Michele',
    company_name: 'MicheleTe',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/it-IT.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922573/1053.jpg?hash=0C2BA1A01F7834AC4F09CB7FD16EC71603DC70BE',
    language: 'Italian (Italy)',
    country: 'Italy',
    callout:
      '"The original is unfaithful to the translation." Jorge Luis Borges'
  },
  {
    id: 2,
    first_name: 'Lucrina',
    company_name: 'LucrinaSt',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/ro-RO.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922563/4950.jpg?hash=FF550F2C1A9FD602B2CB7A72E4567C61AA76A7AD',
    language: 'Romanian (Romania)',
    country: 'Romania',
    callout:
      'I feel so good translating for idioma with my cat purring deeply while curled in my lap.'
  },
  {
    id: 3,
    first_name: 'Evren',
    company_name: 'EvrenBerme',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/tr.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922531/755.jpg?hash=2AC53142DDCF65715806A482EB1AE1F224A9471A',
    language: 'Turkish',
    country: 'Turkey',
    callout:
      'You need to be fast, accurate and on time if you want to live and translate in Istanbul..'
  },
  {
    id: 4,
    first_name: 'Lieve',
    company_name: 'LieveBr',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/nl-NL.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922560/4793.jpg?hash=35EE42BF393CDB4A5C4B2B3167B79EF652F7CCF9',
    language: 'Dutch (Netherlands)',
    country: 'Netherlands',
    callout:
      'What a small country is good at: no one outside of Holland speaks Dutch, but we all speak at least two other non-native languages!'
  },
  {
    id: 5,
    first_name: 'Leire',
    company_name: 'LeireBeras',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/eu.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922558/956.jpg?hash=2DE620BA9C34BC2BD8C5D4DC1B1EAFCCEAA871A2',
    language: 'Basque',
    country: 'Spain',
    callout:
      'Passion for transmitting. Mother languages: Basque and Spanish. Source languages: English and French. Translator and graduate Biologist.'
  },
  {
    id: 6,
    first_name: 'Blazej',
    company_name: 'Blazej',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/pl.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922515/629.jpg?hash=0368A24D86CB08E2C82CBD71648CE1CEA29E73EB',
    language: 'Polish',
    country: 'Poland',
    callout:
      'Just finished simultaneous interpreting at another technical conference! Finally I can focus on the next captivating translation assignment for IDIOMA. Helping people communicate across languages has always been my passion, and that is what still gives me a kick after 13 years in this business.'
  },
  {
    id: 7,
    first_name: 'Lorena',
    company_name: 'LorenaBorg',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/pt-BR.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922561/972.jpg?hash=A34D2B5DD35981EFB64BDF100C6A49CD870564FC',
    language: 'Portuguese (Brazil)',
    country: 'Brazil',
    callout:
      'Living in a big city such as Sao Paulo means you work hard, play hard and enjoy it.'
  },
  {
    id: 8,
    first_name: 'Ana Teodora',
    company_name: 'AnaTeodora',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/ro-RO.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922505/3745.jpg?hash=8A0289897BFF2AE2A09933D53645172644B7A9E8',
    language: 'Romanian (Romania)',
    country: 'United Kingdom',
    callout:
      '"If you talk to a man in a language he understands, that goes to his head. If you talk to him in his language, that goes to his heart." - Nelson Mandela'
  },
  {
    id: 9,
    first_name: 'Anastasia',
    company_name: 'Anastasia',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/ru-RU.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922504/5754.jpg?hash=15ADC54325E5FDFE2030A7F5029B34DD53D28AAE',
    language: 'Russian (Russian Federation)',
    country: 'Russian Federation',
    callout:
      '"It is so easy to combine translation with travelling. The last time I translated for idioma the previous month, I was near the Egyptian pyramids! "'
  },
  {
    id: 10,
    first_name: 'Raita',
    company_name: 'RaitaNitzl',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/de-DE.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922590/1169.jpg?hash=6B4EBF33274776956FF29053B17728F436C75C35',
    language: 'German (Germany)',
    country: 'Austria',
    callout:
      'Now when they are bringing the cattle down from the mountains in Austria… I take my time to translate for idioma.'
  },
  {
    id: 11,
    first_name: 'Ketsiree',
    company_name: 'KetsireeDa',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/th.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922552/929.jpg?hash=8CA206CCCF5FDCBD7B99237B84AF39894BDE1002',
    language: 'Thai',
    country: 'United States of America',
    callout:
      'I am a native Thai and fluent in English. I am currently based out of Detroit, Michigan (not looking forward to the freezing winter!) My professional experience has been in marketing communications, with the past 4.5 years focus in digital marketing.'
  },
  {
    id: 12,
    first_name: 'Matjaz',
    company_name: 'MatjazPro',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/sl.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922571/3934.jpg?hash=3A9210295EACCE7E76FABB332E2F8257D7B65C94',
    language: 'Slovenian',
    country: 'Finland',
    callout:
      'Through dark and rainy months, idioma helps me to burn the midnight oil.'
  },
  {
    id: 13,
    first_name: 'Tânia',
    company_name: 'TaniaPa',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/pt-PT.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922606/1968.jpg?hash=D9FC9F8E4CA9DB4C8974EC622085DB8DED66E77A',
    language: 'Portuguese (Portugal)',
    country: 'Portugal',
    callout:
      'It’s a great day for a walk, but I was thinking since I’m not really up for it, maybe I’ll just stay home and read a nice book.'
  },
  {
    id: 14,
    first_name: 'Ville',
    company_name: 'VilleMeril',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/fi.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922612/4818.jpg?hash=CDEB1DB3BB87DCA7708F1116DBBCA219BA4B69E9',
    language: 'Finnish',
    country: 'Finland',
    callout:
      'I am an English language enthusiast and I love working on my language skills by translating for idioma.'
  },
  {
    id: 15,
    first_name: '​Anamaria',
    company_name: 'Anamaria',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/ro-RO.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922503/4125.jpg?hash=0706C808CF75F59E641A88FDCA47FE72BE39CF31',
    language: 'Romanian (Romania)',
    country: 'Romania',
    callout:
      'Time is moving fast in Bucharest, new things arise at each step, but in a world constantly in motion idioma remains the same: perfect translations.'
  },
  {
    id: 16,
    first_name: 'Karolina',
    company_name: 'KarolinaAstrauskaite',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/lt.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922550/5292.jpg?hash=673EEC697C13416A856429526C4A1A0DF0D85AE1',
    language: 'Lithuanian',
    country: 'Lithuania',
    callout:
      'Such a dreadful weather. Wish I could stay at home and translate something!'
  },
  {
    id: 17,
    first_name: 'Engel',
    company_name: 'PTSGI',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/zh-Hant.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922588/522.jpg?hash=3B9AB3B62F954BDCFACBBBDCE14150C8AB3A6B4B',
    language: 'Chinese Han (Traditional variant)',
    country: 'Taiwan, Province of China',
    callout:
      'A bad reputation lasts for ten thousand years.....but a good reputation lasts a hundred generations!'
  },
  {
    id: 18,
    first_name: 'Jan',
    company_name: 'JanSr',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/sl.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922546/4761.jpg?hash=688EF41EBE104C3A1DAAB31EFC7B25AABF13DCB3',
    language: 'Slovenian',
    country: 'Slovenia',
    callout: 'Always sunny here in Ljubljana...so I translate in the shade!'
  },
  {
    id: 19,
    first_name: 'Miroslav',
    company_name: 'Mikulasko',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/sk.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922575/1062.jpg?hash=A1ECCA498DA342DBDAD52EAD6CEF35B473C1B3BF',
    language: 'Slovak',
    country: 'Slovakia',
    callout:
      'It is a real pleasure to translate together with idioma team professionals...'
  },
  {
    id: 20,
    first_name: 'Francesca',
    company_name: 'FrancescaDe',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/it-IT.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922532/771.jpg?hash=A51FC606C607C7733D7D9CE6D04AF4C5C2403804',
    language: 'Italian (Italy)',
    country: 'Italy',
    callout: '"Translating for idioma, but always close to the beach"'
  },
  {
    id: 21,
    first_name: 'Kyriakos',
    company_name: 'KyriakosKo',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/el.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922556/944.jpg?hash=E2BE9C59D219AF3F32F7BE6F7935889AED56185E',
    language: 'Greek',
    country: 'Denmark',
    callout:
      'Greek interpreter / GIS developer with a predilection for learning new language skills as well as meeting new cultures and ideas.'
  },
  {
    id: 22,
    first_name: 'Alemu',
    company_name: 'AlemuZe',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/am.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922499/5772.jpg?hash=F307F051F3D3F318B52DCE26D58B1544F2561942',
    language: 'Amharic',
    country: 'Ethiopia',
    callout: 'My forte is English to Amharic, Oromo and vice versa.'
  },
  {
    id: 23,
    first_name: 'Jorge',
    company_name: 'JorgeOj',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/es-MX.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922548/1453.jpg?hash=7B861890E136CB2DF332B74B19E66375BB2E82DA',
    language: 'Spanish (Mexico)',
    country: 'Mexico',
    callout: 'Translator, proofreader from Mexico, native Spanish speaker.'
  },
  {
    id: 24,
    first_name: 'Irem',
    company_name: 'IremEr',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/tr.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922540/1484.jpg?hash=19B96D8451B7D6541CC4A4AEEFDFB176B06622FD',
    language: 'Turkish',
    country: 'Sweden',
    callout:
      'Winter again in Gothenburg… It has been rainy, windy and then there is all that snow. It is good to stay indoors, have a cup of coffee and work on some translations.'
  },
  {
    id: 25,
    first_name: 'Edvin',
    company_name: 'Edvin',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/sq.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922527/721.jpg?hash=BB989B149399412CA7435C724B587571B807179D',
    language: 'Albanian',
    country: 'Estonia',
    callout: 'I have been translating for more than 6 years'
  },
  {
    id: 26,
    first_name: 'Michael',
    company_name: 'MichaelMa',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/ro-RO.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922572/2040.jpg?hash=64D4911785BCDECD55759E46F4D36543F41C9A9C',
    language: 'Romanian (Romania)',
    country: 'Romania',
    callout:
      '"Translating for idioma offers you a global outreach, it is great to bring your contribution to such a network."'
  },
  {
    id: 27,
    first_name: 'June',
    company_name: 'JuneVa',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/nb-NO.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922549/905.jpg?hash=3236FBBCC3BB7B4E4CF7D496D4B9ECCBC74CE859',
    language: 'Norwegian Bokmål (Norway)',
    country: 'Spain',
    callout:
      'Working as a legal secretary in Spain, but I am Norwegian, married to a Dutchman.'
  },
  {
    id: 28,
    first_name: 'Rita',
    company_name: 'RitaKr',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/pl.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922595/1189.jpg?hash=38ACB0809A584069C0795F045BD9C46EE26EE9E3',
    language: 'Polish',
    country: 'United Kingdom',
    callout: 'I love to help out with Polish language matters.'
  },
  {
    id: 29,
    first_name: 'Luana',
    company_name: 'LuanaTu',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/it-IT.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922562/975.jpg?hash=0262E0285EF719BA7B79CE3F3BB9EA61219AF2DA',
    language: 'Italian (Italy)',
    country: 'Italy',
    callout: 'One thing well said will be wit in another language'
  },
  {
    id: 30,
    first_name: 'István',
    company_name: 'Istvan',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/hu.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922544/847.jpg?hash=711E47246BD53939A1215DAE3A915CA4B493607C',
    language: 'Hungarian',
    country: 'Hungary',
    callout:
      'My name is István. I live in a small town, which has many advantages compared with living in a big city: there is less noise and more peace – the environment is optimal for making good translations.'
  },
  {
    id: 31,
    first_name: 'Liene',
    company_name: 'LieneAncane',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/lv.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922559/6614.jpg?hash=ECB7906F172B79DE587CC3DE34DD68500ED03C2B',
    language: 'Latvian',
    country: 'Czech Republic',
    callout: 'These dark, silent evenings are perfect...for work!'
  },
  {
    id: 32,
    first_name: 'Kiryl',
    company_name: 'KirylKursh',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/be.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922553/935.jpg?hash=A0DD2F221D53D9D7C64D5FAAC66C7BE25C8EFDDA',
    language: 'Belarusian',
    country: 'Belarus',
    callout: 'Translation is at best an echo...'
  },
  {
    id: 33,
    first_name: 'Dastan',
    company_name: 'DastanOm',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/ru-RU.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922715/1924.png?hash=D7FCC8D7E35F8E8EC15520CD17DC01FDF29E2145',
    language: 'Russian (Russian Federation)',
    country: 'Turkey',
    callout: 'Scientia dux vitae certissimus'
  },
  {
    id: 34,
    first_name: 'Suna',
    company_name: 'SunaPe',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/da.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922601/1259.jpg?hash=E7677276A9D4C836917884F52EAA02775CB55C11',
    language: 'Danish',
    country: 'Denmark',
    callout:
      '38 year-old translator from Denmark. I love my 4 children and have a huge passion for languages, translation and soccer. Honesty, ambition and humour are very important values to me, and as a person I would describe myself as based upon those.'
  },
  {
    id: 35,
    first_name: 'Iryna',
    company_name: 'Iryna',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/uk.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922542/840.jpg?hash=2ABDF4D22033D345A57D07B75496FF005AEEC7CB',
    language: 'Ukrainian',
    country: 'Ukraine',
    callout:
      'I like tennis. No, I’m not a sportswoman.  :). I’m just a fan. During big tournaments, I spend much of my time watching matches, supporting and discussing with fans throughout the world. It’s awesome. Btw, the Davis Cup final will be soon, so join and enjoy. — From Ukraine with love. Love&Peace to U All!'
  },
  {
    id: 36,
    first_name: 'Anja',
    company_name: 'AnjaBo',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/de-DE.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922510/1961.jpg?hash=A20CAFDC35DF20145E3F37278D99F377DBC8325A',
    language: 'German (Germany)',
    country: 'Germany',
    callout:
      'Berlin is just the perfect place to be for me... Fascinating, lively, international, and a million things to do! When I am not translating for idioma, I meet up with different language tandems to have a coffee and talk in English, French, Spanish... and of course German!'
  },
  {
    id: 37,
    first_name: 'Hoang',
    company_name: 'HoangNguye',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/vi.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922538/817.jpg?hash=66034C3FFFD2259535D02BD4592AB64126FEA2C8',
    language: 'Vietnamese',
    country: 'Viet Nam',
    callout:
      'As a freelance translator, I am aware that quality and deadline are the most important priorities. Therefore, I always do my best to offer my best services for long-term cooperation.'
  },
  {
    id: 38,
    first_name: 'Teng-Chian',
    company_name: 'Teng-Chian',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/zh.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922607/1273.jpg?hash=FDE16830282A0A6D23BAF940BB34AD7B1A3E6CC1',
    language: 'Chinese',
    country: 'Sweden',
    callout:
      'The road to professionalism as translator and interpreter: Punctuality, precision, responsibility, durability, readability and comprehensibility. There does not exist shortcuts otherwise.'
  },
  {
    id: 39,
    first_name: 'Nicholas',
    company_name: 'NicholasAh',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/sv-SE.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922581/3681.jpg?hash=293B993ABCF39437FD57FB2E4FCCA65F763CC3DF',
    language: 'Swedish (Sweden)',
    country: 'Sweden',
    callout:
      'As a business law student at the university of Linköping by day and a hockey referee by night, I like to enjoy a cup of black coffee (just a typical Swedish thing) while I catch up on idioma translations between lectures and games.'
  },
  {
    id: 40,
    first_name: 'Ramsyah',
    company_name: 'RamsyahFa',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/id.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922592/3400.jpg?hash=35DB50EED7E5E1751BF8FCCDDF102A8878B3762B',
    language: 'Indonesian',
    country: 'Indonesia',
    callout:
      'Translation in a long dry season like this is not always comfortable, but working with idioma is always exciting and fun!'
  },
  {
    id: 41,
    first_name: 'Edgar',
    company_name: 'Edgar',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/es.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922526/719.jpg?hash=C737B4A96993CDA89EB7B7B1D9DFD199374361CC',
    language: 'Spanish',
    country: 'Czech Republic',
    callout: 'After a thousands words done, time for running'
  },
  {
    id: 42,
    first_name: 'Mariam',
    company_name: 'MariamTs',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/ka.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922567/5773.jpg?hash=91B11F8EEF569A6C5BA19DE52E4CFA5CA42552AC',
    language: 'Georgian',
    country: 'Georgia',
    callout:
      'The bad news is Time flies..BUT the good news is you are the Pilot ;)'
  },
  {
    id: 43,
    first_name: 'Andreea Ioana',
    company_name: 'Andreea IoanaNenciu',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/ro-RO.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922506/5746.jpg?hash=629A4E2992754CF60F090E289A78CB74B5B3944F',
    language: 'Romanian (Romania)',
    country: 'Sweden',
    callout:
      'My favorite quote is from Into the Wild (both book and movie) and I think it guides me through life: "Happiness is real only when shared".'
  },
  {
    id: 44,
    first_name: 'Stefanie',
    company_name: 'StefanieCh',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/ms-MY.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922599/5872.jpg?hash=08EEC6041562CF7EE33A5AA776076A7F2EA24B21',
    language: 'Malay (Malaysia)',
    country: 'United States of America',
    callout: '7 years translation experience in Malay'
  },
  {
    id: 45,
    first_name: '​Imre',
    company_name: 'ImreSz',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/hu.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922539/5306.jpg?hash=091119D986DBEBE8675B93259FE30B641B6F3E89',
    language: 'Hungarian',
    country: 'Hungary',
    callout:
      'I have studied translation in Budapest Business School to be able to meet the highest quality standards and chose swimming to be fit enough for the workloads.'
  },
  {
    id: 46,
    first_name: 'Marita',
    company_name: 'MaritaEr',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/nb-NO.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922570/4766.jpg?hash=3C890FE091D9C6F00BD5DE2288FBC814989D726B',
    language: 'Norwegian Bokmål (Norway)',
    country: 'Norway',
    callout:
      'I have always loved learning new languages, and I received my first 500-page book in English for Christmas when I was 10 years old. My enthusiasm for languages has only increased since then. Between my Japanese studies at university, I enjoy my English-to-Norwegian translation work for idioma.'
  },
  {
    id: 47,
    first_name: 'Chi',
    company_name: 'ChiHo',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/vi.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922517/4768.jpg?hash=62762D1138F054FDACD64B7F236A8DFB5E4E1269',
    language: 'Vietnamese',
    country: 'Norway',
    callout: 'Ready to run!'
  },
  {
    id: 48,
    first_name: 'Akif Cem',
    company_name: 'Akif CemOzkardes',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/tr.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922498/6352.jpg?hash=A935521A50C1DB975761506A1C7D76C1D97A61E7',
    language: 'Turkish',
    country: 'Turkey',
    callout:
      'I wish I would have a chance to translate the secret language of our universe. For now, at least let’s translate those into Turkish!'
  },
  {
    id: 49,
    first_name: 'Maja',
    company_name: 'MajaKolega',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/hr-HR.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922566/4817.jpg?hash=DB2D1D83CF906AA75E7210DCC48EDB2730B8C9C4',
    language: 'Croatian (Croatia)',
    country: 'Croatia',
    callout:
      'A walk on the beach, a tango lesson, having coffee with my friends, spend some time outdoors absorbing all the beauty around me ... and an idioma translation at the end of the day :))))'
  },
  {
    id: 50,
    first_name: 'Mirjana',
    company_name: 'MirjanaVla',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/sr.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922578/1451.jpg?hash=9EC8CA76E76236EE935F75DE3175414FFE83D6D4',
    language: 'Serbian',
    country: 'Serbia',
    callout:
      'Waiting for the Summer to come to Auckland... Nice beaches to visit and just enjoy the Big Blue Sea...'
  },
  {
    id: 51,
    first_name: 'Ana',
    company_name: 'ANA',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/pt-PT.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922502/555.jpg?hash=B4713612B0509DAA7A8C29008C94EC7F69FF4987',
    language: 'Portuguese (Portugal)',
    country: 'Portugal',
    callout:
      'Portugal is known for its pleasant weather, stunning landscapes, superb beaches and delicious food. Lisbon is the perfect city to live and work, particularly if your job is translating for idioma (since 1995).'
  },
  {
    id: 52,
    first_name: 'Angelos',
    company_name: 'AngelosKa',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/el.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922508/568.jpg?hash=F4869FF29A96400C640AA3262F28343C2510EEE7',
    language: 'Greek',
    country: 'United Kingdom',
    callout:
      'Rain and cold is always round the corner in England, so I make myself a cup of coffee (or two) and translate for idioma in the warmth of my home.'
  },
  {
    id: 53,
    first_name: 'Anita',
    company_name: 'AnitaFlis',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/sl.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922509/571.jpg?hash=9B74796FA3D60121F79F0B4F90505197901916FD',
    language: 'Slovenian',
    country: 'Slovenia',
    callout: '10 years of passion for quality Slovenian translations'
  },
  {
    id: 54,
    first_name: 'Anton',
    company_name: 'AntonHa',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/sv-SE.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922511/590.jpg?hash=E7129B39584313A3B773CFDB15CAEC904B6F540A',
    language: 'Swedish (Sweden)',
    country: 'Sweden',
    callout:
      'Language has always fascinated me, with all its depths and nuances. Translating is really a challenge, since it requires me to put into words what is not always directly translatable. In that way I can put my own personal touch into it, which makes it an art!'
  },
  {
    id: 55,
    first_name: 'Helen',
    company_name: 'Helen',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/zh.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922535/804.jpg?hash=7C85C8655BA8C5D6E4D04D8641BD24768D9003E5',
    language: 'Chinese',
    country: 'China',
    callout:
      'It is sunny at last after a long time of cloudy days; I am also in a happy mood after a long time of sadness and depression…Too many things happened recently…anyway, life has to go on and life is so beautiful… I love my family and love my work.'
  },
  {
    id: 56,
    first_name: 'Assia',
    company_name: 'AssiaTerpe',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/bg.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922512/1450.jpg?hash=42A123587EC8F829F9AA39F9EDDB26F70528DA9F',
    language: 'Bulgarian',
    country: 'Spain',
    callout: 'Translating from sunny Valencia'
  },
  {
    id: 57,
    first_name: 'Sofia',
    company_name: 'SofiaLaz',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/el.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922598/2999.jpg?hash=3124CDC5463E4096019A38E88D13390F07F88EB5',
    language: 'Greek',
    country: 'United Kingdom',
    callout:
      'I am busy in the arts sector in Edinburgh and, between my part-time jobs and my ballet classes, I have a busy and varied schedule – I enjoy translating very much and idioma gives me the opportunity to do it whenever I have some spare time!'
  },
  {
    id: 58,
    first_name: 'Jane',
    company_name: 'JaneMa',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/en.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922545/3600.jpg?hash=6EC6AB63F47103201E652EFAFDA2D1E47F4D9CCD',
    language: 'English',
    country: 'United Kingdom',
    callout:
      'Hi from rural England. I have two children, two dogs, two rabbits and six chickens and have been working as a translator for 9 years.'
  },
  {
    id: 59,
    first_name: 'Mircea',
    company_name: 'MirceaPr',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/ro-RO.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922577/4215.jpg?hash=F213B4EF2F40F981D2D05D12E0B15D29CC734599',
    language: 'Romanian (Romania)',
    country: 'Romania',
    callout:
      'Translation is what I do for a living—and idioma is helping a lot with that—and writing fiction is what I also do for a living that transcends the here and now.'
  },
  {
    id: 60,
    first_name: 'Lukasz',
    company_name: 'LukaszRo',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/pl.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922564/4282.jpg?hash=8FDAE70E0A59F81253BCEC883DF80495E6FFAF61',
    language: 'Polish',
    country: 'Poland',
    callout:
      'When I talk about my love I mean my family, when I talk about my hobby I mean fishing and when I talk about my work I mean translations for idioma.'
  },
  {
    id: 61,
    first_name: 'Cristina',
    company_name: 'CristinaBo',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/ro-RO.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922519/4915.jpg?hash=00616210AE089689CD0909C149C5E6B5A89A5ED4',
    language: 'Romanian (Romania)',
    country: 'Romania',
    callout:
      'Full-time freelance translator since 2007, BA in Foreign Languages, MA in Translation Theory and Practice, passionate about my work'
  },
  {
    id: 62,
    first_name: 'Blai',
    company_name: 'BlaiNa',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/es-ES.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922514/626.jpg?hash=A7C210C7310072EFD07A263EC36C9F2B10A41FE4',
    language: 'Spanish (Spain)',
    country: 'Finland',
    callout:
      'Currently working on a new piece written for my instrument. It is always nice to rest while doing some translation for idioma!'
  },
  {
    id: 63,
    first_name: 'Diego',
    company_name: 'DiegoGo',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/es-ES.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922525/707.jpg?hash=C4DB62ABAC2A74BA1793F4BDBFE33B0046492EC1',
    language: 'Spanish (Spain)',
    country: 'Spain',
    callout:
      'You usually find me translating, reading a book or watching stand-up comedy (either on my computer or in a comedy club somewhere in Madrid).'
  },
  {
    id: 64,
    first_name: 'Elisa',
    company_name: 'ElisaTo',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/it-IT.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922530/729.jpg?hash=54EF9653517DC8CFEF0DE592D444E22745FE0834',
    language: 'Italian (Italy)',
    country: 'Italy',
    callout:
      '... quite busy trying to play “Somewhere over the rainbow” with my brand new ukulele… my son is laughing and making horrible faces. I think it’s better to come back to my translation!'
  },
  {
    id: 65,
    first_name: 'Yasser ',
    company_name: 'YasserOrab',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/ar-SA.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922615/1394.jpg?hash=64D9E331EA3D6B424CBF1F3287B980C13E77309C',
    language: 'Arabic (Saudi Arabia)',
    country: 'Egypt',
    callout:
      'The weather is simply beautiful here in Egypt and I listen to the birds chirping on my window sill. What a lovely atmosphere to do some creative translations for idioma!'
  },
  {
    id: 66,
    first_name: 'Adeline',
    company_name: 'Adeline',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/fr-FR.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922495/523.jpg?hash=75025CF9EAA83D8AF00E1E75D175D09715AD9E72',
    language: 'French (France)',
    country: 'France',
    callout:
      'My two children are at school now, so I get a full day to translate for idioma!!'
  },
  {
    id: 67,
    first_name: 'Agnieszka',
    company_name: 'AgnieszkaSk',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/pl.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922497/526.jpg?hash=AB7EDB06F266D0D792E311210510DED14EFD2978',
    language: 'Polish',
    country: 'Finland',
    callout:
      'In a world filled with words, I am trying to find the proper ones, which could explain to my inquisitive daughter all its mysteries in as many languages as I master.'
  },
  {
    id: 68,
    first_name: 'Kuanysh',
    company_name: 'KuanyshZha',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/kk.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922555/943.jpg?hash=5136879E008503598E535D129E61D9C9174BCAED',
    language: 'Kazakh',
    country: 'Kazakhstan',
    callout:
      'It is autumn in Almaty, Kazakhstan, and the city is full of entertainment, but there is always time for idioma translation.'
  },
  {
    id: 69,
    first_name: 'Predrag',
    company_name: 'PredragBo',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/sr.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922587/1158.jpg?hash=29ED7C13306CDC88DC3BD53F10EDD5E2FB392AFE',
    language: 'Serbian',
    country: 'Serbia',
    callout: 'If you can make it, I can translate it.'
  },
  {
    id: 70,
    first_name: 'Newton',
    company_name: 'NewtonMa',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/pt-BR.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922580/1098.jpg?hash=099EE6C18A90A6246485952545D742C8E8F279EA',
    language: 'Portuguese (Brazil)',
    country: 'Brazil',
    callout:
      'Living in Santos, Brazil, the leading port in Latin America, makes me kind of a World Citizen: ships coming and going made me eager to discover about other peoples. Learning languages was a goal, and translating is a natural consequence.'
  },
  {
    id: 71,
    first_name: 'Rael-Saskia',
    company_name: 'Rael-SaskiaSa',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/et.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922589/1166.jpg?hash=8325577DFAC3183A71FA19DE9C22B66BD76884CC',
    language: 'Estonian',
    country: 'Estonia',
    callout: 'From Estonia with my cat, dog and books.'
  },
  {
    id: 72,
    first_name: 'Pavel',
    company_name: 'PavelZatlo',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/cs.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922584/1135.jpg?hash=81BA0FB332D40E65E7CACFC635DE92B6C354751B',
    language: 'Czech',
    country: 'Czech Republic',
    callout:
      'It seems to be a surprising career twist: studying evolutionary biology and subsequently ending up as a translator. I see it as a blessing. Not only does it give me an edge in my work, but also a unique perspective on interpersonal relationships and on life itself.'
  },
  {
    id: 73,
    first_name: 'Rajesh',
    company_name: 'RajeshKuma',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/hi.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922591/1170.jpg?hash=724343FEBC484A8B45434972D5BD69128664B149',
    language: 'Hindi',
    country: 'India',
    callout: 'Trust me for Quality and Quick turn-around!'
  },
  {
    id: 74,
    first_name: 'Serdar',
    company_name: 'SerdarAc',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/tr.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922596/1226.jpg?hash=7E7A012414B8757203F7545B5E8F660AD0AAFEA8',
    language: 'Turkish',
    country: 'Turkey',
    callout:
      'Currently in Istanbul, the city that spans over two continents and a place where I constantly try to be somewhere on time and fail. Well... at least the views are nice.'
  },
  {
    id: 75,
    first_name: 'Tiziana',
    company_name: 'TizianaCu',
    flag: '',
    photo:
      'https://tc6.idioma.com/file-download/1922608/1290.jpg?hash=18CD966B628C39AC71A12E38DC6FAD7A431BD6CC',
    language: '',
    country: 'Italy',
    callout:
      'Living in Sardinia, there is nothing better than working for idioma lying on one of our fabulous beaches!'
  },
  {
    id: 76,
    first_name: 'Susanna',
    company_name: 'SusannaSa',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/de-DE.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922602/1262.jpg?hash=55D98D4E5B2E4C86AF45D41BFE9CD150CCD986BE',
    language: 'German (Germany)',
    country: 'Germany',
    callout:
      'Digging in my garden, running with the dog and from time to time: relax with an idioma translation :-)'
  },
  {
    id: 77,
    first_name: 'Gabriela',
    company_name: 'GabrielaUj',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/sk.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922533/1377.jpg?hash=26FF8DEFFCB2E7547E3B68ED19BAFE8DEABAB7BC',
    language: 'Slovak',
    country: 'Slovakia',
    callout:
      'Green tea prepared, fire set in the fireplace, iQube open and a bar of chocolate within close reach ... let´s start translating :-)'
  },
  {
    id: 78,
    first_name: 'Katia',
    company_name: 'Katia',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/pt-BR.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922551/922.jpg?hash=5BAD6FD36876EAC8B83D8CA85031DFAA61160CA2',
    language: 'Portuguese (Brazil)',
    country: 'Brazil',
    callout:
      'I live and work for ten months on a beautiful mountain city named Nova Friburgo that has a mild climate, dreaming of two months of sun and beach in the wonderful city named Rio.'
  },
  {
    id: 79,
    first_name: 'Miha',
    company_name: 'MihaLenic',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/sl.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922574/1059.jpg?hash=727CD515B3D17ACA8B40D7847C74E963D3B0B38F',
    language: 'Slovenian',
    country: 'Slovenia',
    callout:
      'Translating... you can do it anywhere! I just moved to Paris and it is awesome. And you never know where I will be in two years, but you can always reach me by email ;)'
  },
  {
    id: 80,
    first_name: 'Sylvia',
    company_name: 'SylviaA',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/bg.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922604/1267.jpg?hash=1A73E92E0C6D19AA9AAA2CF87644BF9F1A10CC98',
    language: 'Bulgarian',
    country: 'Bulgaria',
    callout:
      'I love sunny weather, sitcoms, rock-n-roll, coffee breaks, my tablet and my super-chromatic peril sensitive sunglasses... Looking forward to our next idioma project!'
  },
  {
    id: 81,
    first_name: 'Ángel',
    company_name: 'AngelMo',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/es-ES.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922507/1940.jpg?hash=D1ECEDFC34544056C4AF4BAD2124BBC1C55B280F',
    language: 'Spanish (Spain)',
    country: 'Spain',
    callout:
      'Translatin´!! I love it !! Gimme more translations!! I can never get enough!!'
  },
  {
    id: 82,
    first_name: 'Valerio',
    company_name: 'Valerio',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/it-IT.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922610/1313.jpg?hash=A91B62E8ED4278333DB8894E0DD46A84D292ABAE',
    language: 'Italian (Italy)',
    country: 'Italy',
    callout:
      'Enjoying an endless summer riding my bicycle in southern Italy... :)'
  },
  {
    id: 83,
    first_name: 'Noa',
    company_name: 'DIAZE',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/es.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922524/705.jpg?hash=673425E4A9433CAD4AA9783A5F20FF524CABA130',
    language: 'Spanish',
    country: 'United Kingdom',
    callout:
      'If I had to pick the most rewarding aspect of translating it would be knowing that our work helps to break down frontiers and facilitate the building of international relationships.'
  },
  {
    id: 84,
    first_name: 'Oscar',
    company_name: 'OscarLuna',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/es-MX.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922583/6565.jpg?hash=D66EAF11A200222EE846B48EFE236B5CCDC5CAFF',
    language: 'Spanish (Mexico)',
    country: 'Argentina',
    callout: 'Engineer and professional translator'
  },
  {
    id: 85,
    first_name: 'Mildred',
    company_name: 'MildredSi',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/nl-NL.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922576/2194.jpg?hash=6081BD9E47EF60741E69E6F89449118649CABF0A',
    language: 'Dutch (Netherlands)',
    country: 'Netherlands',
    callout:
      'Let’s start with some proofreading work for idioma! and enjoy a nice cup of fresh coffee and home made apple pie on a bright and sunny Sunday afternoon on my terrace. I enjoy translating and proofreading whenever and wherever I am, but also whenever I have time. This is an ideal way of working being a freelancer.'
  },
  {
    id: 86,
    first_name: 'Ayan',
    company_name: 'AyanZhibit',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/kk.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922513/605.jpg?hash=376BA0D2A4E608DA0CA849B0755ABB5FFD9332BC',
    language: 'Kazakh',
    country: 'Kazakhstan',
    callout:
      'I love travelling..and translating...I love the latter, because it´s one of those few jobs that can be perfectly combined with the former'
  },
  {
    id: 87,
    first_name: 'Ratka',
    company_name: 'RatkaDj',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/sr.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922593/1175.jpg?hash=4BC0F89CE2C54DE270A571B19D5997CDE4BFDC47',
    language: 'Serbian',
    country: 'Serbia',
    callout:
      'The Danube river that cuts Belgrade into halves accommodates numerous barges turned into floating cafes called “splavs”. I’m fortunate to be living near one of those, so I often take my laptop, order a frappe and translate for idioma.'
  },
  {
    id: 88,
    first_name: 'Petr',
    company_name: 'PetrLu',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/cs.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922586/1150.jpg?hash=1248B01858534B0A132F2DD13F216EC821C5A1A7',
    language: 'Czech',
    country: 'Czech Republic',
    callout:
      'There are two things I really love: Travelling and languages!!! And when translating for idioma, I can enjoy both of them at the same time :)'
  },
  {
    id: 89,
    first_name: 'Svetlana',
    company_name: 'SvetlanaSa',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/ru-RU.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922603/1264.jpg?hash=1E92399AA31A20BE3A5D9220BEEA3F5DAF153083',
    language: 'Russian (Russian Federation)',
    country: 'Russian Federation',
    callout:
      'It’s amazing to be a part of this world class linguistic team! Five years, and I am so proud to have served millions of Russian language users around the World.'
  },
  {
    id: 90,
    first_name: 'William',
    company_name: 'WilliamPa',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/ro-RO.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922614/1341.jpg?hash=DB0E52A84034C8859F4E90E0F46521B670EA0AEE',
    language: 'Romanian (Romania)',
    country: 'Romania',
    callout:
      'Cleaning out the wrong words from a translation, this might be a good idea :)'
  },
  {
    id: 91,
    first_name: 'Renata',
    company_name: 'RenataSa',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/cs.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922594/1177.jpg?hash=788D067CA1B709E64D877BEFF4A40BBADC0785F1',
    language: 'Czech',
    country: 'Czech Republic',
    callout:
      'When translating I keep my brain trained, with kitesurfing I keep my body fit, and my family and good food make me always happy.'
  },
  {
    id: 92,
    first_name: 'Irene',
    company_name: 'IreneMarag',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/fr.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922541/836.jpg?hash=F47EA27C59DDFF27907EBE3D1E89F74F8AED9351',
    language: 'French',
    country: 'Greece',
    callout:
      'A happy Canadian camper that is guilty of all things Canadian: says thank you way too many times and thinks steak served with maple syrup is completely normal!'
  },
  {
    id: 93,
    first_name: 'Isabel',
    company_name: 'IsabelBanc',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/es-MX.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922543/841.jpg?hash=FFDDCCA213192CCBE8F3FF83C7157CA68478A202',
    language: 'Spanish (Mexico)',
    country: 'Argentina',
    callout:
      'Buenos Aires, Argentina. I’ve just arrived home from my Tango lessons. I feel refreshed and inspired to catch up with my idioma translation.'
  },
  {
    id: 94,
    first_name: 'Konstantina',
    company_name: 'KonstantinaKa',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/el.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922554/937.jpg?hash=45108DB746BC50D64785691CFDA71713B82B9F9D',
    language: 'Greek',
    country: 'Greece',
    callout:
      'I love early morning awakenings: after having taken care my plants, I enjoy my coffee while I’m translating for idioma on my porch. In the background, I hear the noises of crowded and bustling Athens … and I feel so lucky!'
  },
  {
    id: 95,
    first_name: 'Eleni',
    company_name: 'EleniTr',
    flag: 'https://tc6.idioma.com/Content/images/flags-map/el.jpg',
    photo:
      'https://tc6.idioma.com/file-download/1922529/1941.jpg?hash=1E441E5FE0471B909FC179745CF67368997F42BE',
    language: 'Greek',
    country: 'Greece',
    callout: '"..... keep translating... :)...."'
  }
]
